import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineOverviewDiagramContent } from "./EndocrineOverviewDiagram";
import { EndocrineOverviewKeyContent } from "./EndocrineOverviewKey";

const SvgEndocrineOverviewDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1344, 1584)}
      viewBox={diagramOnly ? "0 204 1024 1344" : "0 0 1024 1584"}
    >
      <g id="endocrine-overview-diagram+key" clipPath="url(#clip0_18293_224300)">
        <rect width={1024} height={diagramOnly ? 1344 : 1584} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineOverviewKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 36)` : undefined}>
          <EndocrineOverviewDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224300">
          <rect width={1024} height={1584} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224300">
          <rect width={1024} height={1344} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineOverviewDiagramKey;
